import { Injectable } from '@angular/core';

import { BaseService } from '../abstracts/base.service';
import { ClassroomModel } from '../models/classroom.model';
import { ResultModel } from '../models/result.model';
import { ClassLevelModel } from '../models/classlevel.model';
import { QuestionModel } from '../models/question.model';
import { QuestionMessageModel } from '../models/question-message.model';
import { VirtualClassModel } from '../models/virtual-class.model';
import { ClassModel } from '../models/class.model';
@Injectable({
  providedIn: 'root'
})
export class VirtualClassService extends BaseService {

  create(virtualClass: VirtualClassModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl("virtual-classes"), virtualClass);
  }

  get(virtualClassID: string) {
    return this.httpClient.get<ResultModel<VirtualClassModel>>(this.getApiUrl(`virtual-classes/${virtualClassID}`));
  }

  update(virtualClass: VirtualClassModel) {
    return this.httpClient.put(this.getApiUrl('virtual-classes'), virtualClass);
  }

  delete(virtualClassID: string) {
    return this.httpClient.delete<ResultModel<VirtualClassModel>>(this.getApiUrl(`virtual-classes/${virtualClassID}`));
  }

  startVirtualClass(virtualClassID: string) {
    return this.httpClient.post<ResultModel>(this.getApiUrl(`virtual-classes/${virtualClassID}/start`), {});
  }

  finishVirtualClass(virtualClassID: string) {
    return this.httpClient.post<ResultModel>(this.getApiUrl(`virtual-classes/${virtualClassID}/finish`), {});
  }

  startVirtualClassNew(virtualClassID: string, timeTableID: string, lessonName: string) {
    var formData = new FormData;
    formData.append('pVirtualClassID', virtualClassID);
    formData.append('pTimeTableID', timeTableID);
    formData.append('pLessonName', lessonName);
    return this.httpClient.post<ResultModel>(this.getApiUrl(`virtual-class/start`), formData);
  }

  finishVirtualClassNew(virtualClassID: string) {
    return this.httpClient.post<ResultModel>(this.getApiUrl(`virtual-class/finish?pVirtualClassID=${virtualClassID}`), {});
  }

  attendVirtualClassNew(virtualClassID: string) {
    return this.httpClient.post<ResultModel>(this.getApiUrl(`virtual-class/attend?pVirtualClassID=${virtualClassID}`), {});
  }

  listAllByClassID(classID: string, formData?: FormData) {
    return this.httpClient.post<ResultModel>(this.getApiUrl(`virtual-classes/list?pClassID=${classID}`), formData);
  }

  listAll(formData?: FormData) {
    return this.httpClient.post<ResultModel<VirtualClassModel[]>>(this.getApiUrl("virtual-classes/lists"), formData);
  }

  listAllForTraining(trainingID: any) {
    return this.httpClient.get<ResultModel<any[]>>(this.getApiUrl("virtual-classes/list?pTrainingID=" + trainingID));
  }

  ProvidersVirtualClass(virtualClassID: string, formData?: FormData) {
    return this.httpClient.put<ResultModel>(this.getApiUrl(`virtual-classes/${virtualClassID}/provider`), formData);
  }



  //
  listAllNew(formData?: FormData, pFilterDate?: Date) {

    var dateParam = '';
    if (pFilterDate) {
      let dateOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };
      dateParam = '?pFilterDate=' + pFilterDate.toLocaleDateString('tr-TR', dateOptions);
    }
    return this.httpClient.post<ResultModel<VirtualClassModel[]>>(this.getApiUrl(`virtual-class/list${dateParam}`), formData);
  }

  listAllCompleteNew(formData?: FormData, pFilterDate?: Date) {
    var dateParam = '';
    if (pFilterDate) {
      let dateOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };
      dateParam = '?pFilterDate=' + pFilterDate.toLocaleDateString('tr-TR', dateOptions);
    }
    return this.httpClient.post<ResultModel<VirtualClassModel[]>>(this.getApiUrl(`virtual-class/completelist${dateParam}`), formData);
  }

  listAllNewForCard(pClassID: string, pListType: string, pFilterDate?: Date) {
    var dateParam = '';
    if (pFilterDate) {
      let dateOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };
      dateParam = '&pFilterDate=' + pFilterDate.toLocaleDateString('tr-TR', dateOptions);
    }
    return this.httpClient.get<ResultModel<VirtualClassModel[]>>(this.getApiUrl(`virtual-class/list-card?pClassID=${pClassID}&pListType=${pListType}${dateParam}`));
  }

  participantStudentList(sanalsinif_id) {
    return this.httpClient.get<ResultModel<VirtualClassModel[]>>(this.getApiUrl(`virtual-class/ParticipantStudentList?pSanalSinifID=${sanalsinif_id}`));
  }


  dataParticipantStudent(sanalsinif_id) {
    return this.httpClient.get<ResultModel<VirtualClassModel[]>>(this.getApiUrl(`virtual-class/DataParticipantStudent?pSanalSinifID=${sanalsinif_id}`));
  }


}
